import React from "react";

const logo = `${process.env.PUBLIC_URL || ""}/coke-studio-logo.png`;

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#E61A27",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px 100px 20px",
    boxSizing: "border-box",
    fontFamily: "Georgia, 'Times New Roman', serif",
    position: "relative",
  },
  logoWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "clamp(24px, 4vw, 48px)",
  },
  logo: {
    width: "clamp(110px, 14vw, 170px)",
    height: "clamp(110px, 14vw, 170px)",
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
  },
  panel: {
    border: "2px solid #000",
    padding: "10px",
    width: "min(1100px, 92%)",
    boxSizing: "border-box",
  },
  innerBorder: {
    border: "1px solid #fff",
    padding: "clamp(24px, 4vw, 48px) clamp(20px, 4vw, 40px)",
    textAlign: "center",
    boxSizing: "border-box",
  },
  whiteText: {
    color: "#fff",
    fontSize: "clamp(18px, 2.4vw, 30px)",
    fontWeight: 700,
    lineHeight: 1.35,
    margin: 0,
  },
  blackText: {
    color: "#0b0b0b",
    fontSize: "clamp(18px, 2.4vw, 30px)",
    fontWeight: 700,
    lineHeight: 1.35,
    margin: "clamp(14px, 2vw, 22px) 0 0 0",
  },
  exploreBtn: {
    display: "inline-block",
    marginTop: "clamp(18px, 2.5vw, 28px)",
    padding: "clamp(10px, 1.4vw, 14px) clamp(24px, 3vw, 36px)",
    // backgroundColor: "#000",
    color: "#fff",
    fontSize: "clamp(14px, 1.6vw, 18px)",
    fontWeight: 700,
    textDecoration: "none",
    border: "2px solid #fff",
    borderRadius: "999px",
    fontFamily: "Georgia, 'Times New Roman', serif",
    cursor: "pointer",
    letterSpacing: "0.5px",
  },
};

function ExperienceEnded() {
  return (
    <>
      <div style={styles.page}>
        <div style={styles.logoWrap}>
          <img src={logo} alt="Coke Studio" style={styles.logo} />
        </div>

        <div style={styles.panel}>
          <div style={styles.innerBorder}>
            <p style={styles.whiteText}>
              The Coke Studio<sup>®</sup> experience has ended.
              <br />
              Thank you for your participation.
            </p>
            <p style={styles.blackText}>
              Click below to explore more in the
              <br />
              World of Coke<sup>®</sup>.
            </p>
            <a
              href="https://api.whatsapp.com/send?phone=919650877399&text=Hi!!+I%27am+here+to+unlock+the+magical+world+Coke%C2%AE.+By+pressing+%22send%27+on+this+message%2C%2C+I+consent+to+sharing+my+Mobile+number+and+Display+name+with+Coca-Cola%C2%AE.&dclid=CIDs39aD0ZIDFaNynQkd_fImJg&gad_source=7&gad_campaignid=23434964776"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.exploreBtn}
            >
              Explore More
            </a>
          </div>
        </div>
      </div>

      <style>{`
        .ce-footer {
          position: fixed;
          left: 0;
          bottom: 0;
          width: 100%;
          z-index: 9;
          background-color: #000;
          padding: 7px;
          font-family: Roboto, Arial, sans-serif;
          box-sizing: border-box;
        }
        .ce-footer-container {
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 0;
          box-sizing: border-box;
        }
        .ce-footer-row {
          display: flex;
          gap: 8px;
          align-items: center;
          justify-content: center;
        }
        .ce-footer-left {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          width: 60%;
          text-align: left;
        }
        .ce-footer-caption {
          width: calc(100% - 25px);
        }
        .ce-footer-text {
          margin: 0;
          color: #fff;
          font-weight: 500;
          text-transform: uppercase;
          font-size: 0.6vh;
          line-height: 8px;
        }
        .ce-footer-text .ce-maaza {
          display: block;
        }
        .ce-footer-links {
          list-style: none;
          margin: 0 auto;
          padding: 0;
          display: flex;
          gap: 10px;
          align-items: center;
          justify-content: flex-end;
          width: 40%;
        }
        .ce-footer-link {
          font-size: 1vh;
          color: #fff;
          text-decoration: none;
          display: block;
        }
        @media (min-width: 768px) {
          .ce-footer-text {
            font-size: 0.7vh;
            line-height: 12px;
          }
          .ce-footer-text .ce-maaza {
            display: inline;
          }
          .ce-footer-link {
            font-size: 0.7vh;
          }
        }
        @media (min-width: 1024px) {
          .ce-footer-links {
            width: 30%;
          }
          .ce-footer-text,
          .ce-footer-link {
            font-size: 12px;
          }
        }
      `}</style>

      <footer className="ce-footer">
        <div className="ce-footer-container">
          <div className="ce-footer-row">
            <div className="ce-footer-left">
              <div className="ce-footer-caption">
                <p className="ce-footer-text">
                  © 2026 The Coca-Cola Company. All rights reserved.
                </p>
              </div>
            </div>
            <ul className="ce-footer-links">
              <li>
                <a
                  className="ce-footer-link"
                  href="/Terms_of_Use_2026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  *Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a
                  className="ce-footer-link"
                  href="/Privacy_Policy_cokestudio.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default ExperienceEnded;
